import React from 'react'
import Bimanbastralaya from "../images/bimanbastralaya-head.jpg";
import Bimanbastralayashowroom from "../images/bimambastralayashowroom.jpg";
import Navbar from '../inc/Navbar';
function Aboutus() {
  return (
    <div>

      <Navbar />
      <br />
      <br />
      <br />
      <br/>
      <img src={Bimanbastralaya} className="d-block w-100" alt="Bimanbastralaya" />
      <div className='about'>
      <div className="album py-4">

        <div className="container">

          <div className="row">

            <div className="col-md-8 mt-3">


              <h1 style={{ color: "#025E75" }} className="card-text"> <b>About Us – Biman Bastralaya</b></h1>
              <p  className="card-text"> Since the year 2000, Biman Bastralaya has been a trusted name in garments and fashion in Karimpur. Over the past two decades, we have built our reputation by offering quality clothing, the latest trends, and exceptional customer service.</p>
              <p  className="card-text">From traditional ethnic wear to modern outfits, our showroom brings together a wide variety of garments for men, women, and children – all under one roof. We believe in blending style, comfort, and value, ensuring that every customer finds something special for every occasion.
              </p>
<p><small>Our commitment to quality and trust has made us one of the most preferred garment showrooms in the region. At Biman Bastralaya, shopping is more than just a purchase – it’s an experience.</small></p>
           

              <div className="d-flex justify-content-between align-items-center">


              </div>

            </div>
            <br />
            <div className="col-md-4 mb-3" >
               <div className="radius">
                <img src={Bimanbastralayashowroom} className="card-img-top" alt="Bimanbastralayashowroom" />
              </div>

             

            </div>
            </div>






          </div>


        </div>

      </div>

      <hr />

    </div>
  )
}

export default Aboutus
